import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sentinel.containers.search.title',
    defaultMessage: 'Search',
  },
});



// WEBPACK FOOTER //
// ./src/containers/Search/messages.js